import {ScreenLock} from "../../__constants/lock-screen";

const $ = jQuery.noConflict();

export const VideoPopup = (() => {
    const videoTrigger = $('[data-video-id]');
    const videoPopup = $('.video-popup');
    const iframe = videoPopup.find('iframe');
    const closeTrigger = videoPopup.find('.close');

    videoTrigger.on('click', (e) => {
        e.preventDefault();
        const videoID = $(e.delegateTarget).data('video-id');
        iframe.attr('src', `//www.youtube.com/embed/${videoID}`);
        videoPopup.fadeIn(300);
        ScreenLock.lock();
    });

    closeTrigger.on('click', () => {
        videoPopup.fadeOut(300);
        iframe.attr('src', '');
        ScreenLock.unlock();
    });

});
